import { motion } from "framer-motion";
import { LockKey } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api } from "../../lib/api";

function UpsellCard({ title, description, type }) {
  const handleClick = async () => {
    try {
      await api.post("/client/upsell-click", { type });
      toast.success("Our team has been notified and will reach out shortly.");
    } catch {
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="relative bg-igc-surface border border-igc-gold/15 p-6 flex flex-col justify-between" data-testid={`locked-upsell-${type}`}>
      <div className="flex items-start justify-between mb-3 gap-3">
        <p className="font-serif text-lg text-igc-cream">{title}</p>
        <span className="flex items-center gap-1 text-[10px] uppercase tracking-widest text-igc-goldText/70 whitespace-nowrap mt-1">
          <LockKey size={13} weight="duotone" /> Not Enabled
        </span>
      </div>
      <p className="text-igc-muted text-sm mb-5">{description}</p>
      <button
        data-testid={`unlock-upsell-${type}`}
        onClick={handleClick}
        title="Lets our team know you're interested — someone from IGC will reach out to walk you through this service."
        className="w-full border border-igc-gold text-igc-goldText px-4 py-2.5 text-xs uppercase tracking-widest hover:bg-igc-gold hover:text-black transition-colors hover:-translate-y-0.5"
      >
        Inquire About This Service
      </button>
    </div>
  );
}

export function LockedUpsells() {
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.35 }} className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <UpsellCard
        type="trust"
        title="Asset Protection & Trust Services"
        description="Protect your business and personal assets with IGC's Trust & Asset Protection program. Click below and our team will reach out with details on eligibility and setup."
      />
      <UpsellCard
        type="funding"
        title="Business Funding Pipeline"
        description="Access growth capital through IGC's Business Funding program. Click below and our team will reach out with funding options tailored to your store."
      />
    </motion.div>
  );
}
